var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/elevator.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("平安电梯/商业中央空调雇主险")]),
                  _c("div", [_vm._v("高性价比 | 平安财险 | 线上操作")]),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t① 电梯、商业中央空调定制方案，不限品牌\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t② 最高保额可达120万，满足企业用工需求\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t③ 住院误工补贴，出院后也能赔\n\t\t\t\t\t"
                    ),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t社保用药范围100%赔付，免赔100元，伤残等级对应赔付比例请查看附表\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataBenefit,
                        option: _vm.optionBenefit,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { column: 1, border: "", title: "注意事项" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "投保年龄" } }, [
                    _vm._v("投保年龄限16-65周岁"),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "可投保职业" } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t本保单被保险人雇员为电梯/商业中央空调安装、运营、维护等（不含制造）相关人员\n\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c("span", [_vm._v(_vm._s(qa.answer))]),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c(
                        "p",
                        { staticStyle: { "line-height": "32px" } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t1. 本保险适用以下保险条款\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "link" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { color: "DodgerBlue" },
                                attrs: {
                                  href: "pingan1.html",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t中国平安财产保险股份有限公司雇主责任保险条款（A款）\n\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t2、本保险由中国平安财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "link" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { color: "DodgerBlue" },
                                attrs: {
                                  href: "https://property.pingan.com/gongkaixinxipilu/fenzhijigou.shtml",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t省级分支机构和落地服务机构\n\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t4、保险公司全国统一的客户服务及投诉方式详见如下链接：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "link" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { color: "DodgerBlue" },
                                attrs: {
                                  href: "https://property.pingan.com/gongkaixinxipilu/gongsigaikuang.shtml",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t全国统一的客户服务及投诉方式\n\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t8、本保险根据投保单位的需求提供电子发票或纸质专票。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t9、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t10、本保单项下发生退保的，按下述短期费率表收取短期保费：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("avue-crud", {
                            ref: "crud",
                            attrs: {
                              data: _vm.dataShortPeriodRate,
                              option: _vm.optionShortPeriodRate,
                            },
                          }),
                          _vm._v(
                            "\n\t\t\t\t\t\t（注：1、保险期间已经过月数不足一月的按一月计算 2、保单项下发生索赔的，退还保费为0）。\n\t\t\t\t\t"
                          ),
                        ],
                        1
                      ),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c(
                        "p",
                        { staticStyle: { "line-height": "32px" } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t1、本保单被保险人雇员为电梯/商业中央空调安装、运营、维护等（不含制造）相关人员，投保年龄限16-65周岁（不超65），与被保险人签订有劳动合同或存在事实劳动合同关系，接受被保险人给付薪金、工资，包括正式在册职工、短期工、临时工、季节工和徒工等相关工作人员。本保单采用记名承保，在保员工以投保人提供的人员名单及其身份证号码为准。如发生保险事故，保险人雇员实际从事工作与电梯/商业中央空调行业不相关，则保险人不予赔付。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t2、本保单的共同被保险人包括但不限于保单约定的被保险人及其分销商、二级网点。但是其分销商、二级网点在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t3、在保险期间内，被保险人的在保员工在受雇过程中因从事被保险人所安排的企业经营范围内的工作（不限电梯/商业中央空调品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t4、被保险人的在保员工在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t5、在上下班途中，保险人仅承保：被保险人雇员遭遇非主要责任的交通事故，或者城市轨道交通、客运轮渡、火车事故伤害，从而导致被保险人应承担的经济赔偿责任。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t6、本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费用、法律费用，每项保障项目的赔偿限额应在保单明确载明。如发生保险事故，保险人赔偿金额不超过赔偿限额。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t7、在保险期间内，发生保险责任范围内的意外事故，保险人根据被保险人投保的人员名册，对发生死亡、伤残的人员按下列标准赔偿：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿限额为死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人可提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c(
                            "avue-crud",
                            {
                              ref: "crud",
                              attrs: {
                                data: _vm.dataBenefit,
                                option: _vm.optionBenefit,
                              },
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("span", [_vm._v("伤残等级赔偿限额比例表")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(
                            "\n\t\t\t\t\t\t伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t8、医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t9、医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按100%比例给付医疗保险金，免赔100元。如果被保险人已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t10、误工费赔付特别约定：暂时丧失工作能力且需住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的证明，保险人按照人民币100元/人/天的标准，以最长180天为限计算误工费,\n\t\t\t\t\t\t免赔3天。误工费计算包含住院期间以及出院后的休息误工时间，其中出院后休息误工时间取医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中的最小时间，且一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据(7)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险员工的工资证明。出险员工仅需门诊治疗的，按本保单约定无误工费赔付。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t11、扩展法律费用条款：在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t12、所有承保人员须经过岗前安全培训,合格后方可上岗,\n\t\t\t\t\t\t发生伤残和死亡时须提供相关职业资格证书，或企业出具的可证明实际用工关系的材料（如劳动合同、工资发放记录、系统工单截图等）。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t13、针对空调安装工作，本保单仅承保商业中央空调的安装维修保养工作，作业人员出高空外墙进行空调安装维修作业时发生的伤亡，本保单不承担赔偿责任。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t14、本保单指定医院范围为：卫生部规定的大陆境内二级及二级以上公立医院或保险人认可的医疗机构，但不包括以下地区的医疗机构：北京市平谷区、密云县、怀柔区所有医疗机构、辽宁铁岭县、河北青县、河北青龙县、廊坊市、山东禹城市以及河南信阳市的所有医院，中国医科大学附属盛京医院，荆州市妇幼保健院，保定市第一医院，山东齐鲁医院，四川省宜宾市的所有医疗机构、四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、天津滨海、静海地区医院。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t15、山东省地区的仅承保美的签约网点的持证员工。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t16、被保险人必须在保险事故发生后48小时内报案，报案电话95511，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险赔偿责任的80%予以赔付。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。被保险人取得报案号后才是报案成功（否则报案失败）。如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致被保险人按上述约定扣除免赔，则被保险人须自行承担相关损失。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t17、本保单项下发生退保的，按下述短期费率表收取短期保费：\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("avue-crud", {
                            ref: "crud",
                            attrs: {
                              data: _vm.dataShortPeriodRate,
                              option: _vm.optionShortPeriodRate,
                            },
                          }),
                          _vm._v(
                            "\n\t\t\t\t\t\t（注：1、保险期间已经过月数不足一月的按一月计算 2、保单项下发生索赔的，退还保费为0）。\n\t\t\t\t\t\t"
                          ),
                          _c("br"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }